import clsx from 'clsx'
import {
  // KTSVG,
  // toAbsoluteUrl,
} from '../../../helpers'
import {
  // HeaderNotificationsMenu,
  HeaderUserMenu,
  // Search,
  // ThemeModeSwitcher,
} from '../../../partials'
import { useAuthStore } from 'Store/Auth'
// import { useLayout } from '../../core'

const itemClass = 'ms-1 ms-lg-3'
// const btnClass =
// 	'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const fallbackAvatarImage = '/media/avatars/blank.png'
const employeeImageBaseUrl = 'https://api.thaiconstech.com'
// const btnIconClass = 'svg-icon-1'

const resolveEmployeeImageUrl = (employeePicPath?: string) => {
  if (!employeePicPath) return undefined

  const normalizedBaseUrl = employeeImageBaseUrl.endsWith('/')
    ? employeeImageBaseUrl.slice(0, -1)
    : employeeImageBaseUrl
  const normalizedPath = employeePicPath.startsWith('/') ? employeePicPath : `/${employeePicPath}`

  return `${normalizedBaseUrl}${normalizedPath}`
}

const Navbar = () => {
  const profile = useAuthStore(state => state.profile)
  const employeeImageUrl = resolveEmployeeImageUrl(profile?.employeePicPath)
  // const { config } = useLayout()
  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
				<Search />
			</div>

			<div className={clsx('app-navbar-item', itemClass)}>
				<div id="kt_activities_toggle" className={btnClass}>
					<KTSVG path="/media/icons/duotune/general/gen032.svg" className={btnIconClass} />
				</div>
			</div>

			<div className={clsx('app-navbar-item', itemClass)}>
				<div
					data-kt-menu-trigger="{default: 'click'}"
					data-kt-menu-attach="parent"
					data-kt-menu-placement="bottom-end"
					className={btnClass}>
					<KTSVG path="/media/icons/duotune/general/gen022.svg" className={btnIconClass} />
				</div>
				<HeaderNotificationsMenu />
			</div>

			<div className={clsx('app-navbar-item', itemClass)}>
				<div className={clsx('position-relative', btnClass)} id="kt_drawer_chat_toggle">
					<KTSVG path="/media/icons/duotune/communication/com012.svg" className={btnIconClass} />
					<span className="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" />
				</div>
			</div>

			<div className={clsx('app-navbar-item', itemClass)}>
				<ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
			</div> */}

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer d-flex align-items-center fw-semibold fs-2 text-gray-800 text-hover-primary')}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'>
          <img
            src={employeeImageUrl ?? fallbackAvatarImage}
            alt={profile?.fullName ?? 'user profile'}
            className='rounded-circle object-fit-cover me-2'
            style={{ width: '32px', height: '32px' }}
            onError={e => {
              e.currentTarget.onerror = null
              e.currentTarget.src = fallbackAvatarImage
            }}
          />
          {profile?.fullName ?? '-'}
        </div>
        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'>
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}

export { Navbar }
